<template>
    <floating-actions v-if="!$vuetify.breakpoint.mobile" right top bottom class="pr-4">
        <v-hover v-model="hovers">
            <v-card class="quick-menu" :class="{ hovers }" rounded="xl">
                <img src="/images/point.png" class="point" />
                <v-btn text tile width="80" height="80" active-class="no-active" class="pa-0" block @click="hovers = !hovers">
                    <div class="text-center">
                        <v-icon color="grey" size="32" class="d-block mx-auto">
                            <template v-if="hovers">
                                mdi-chevron-right
                            </template>
                            <template v-else>
                                mdi-chevron-left
                            </template>
                        </v-icon>
                    </div>
                </v-btn>
                <v-btn v-if="logoff" text tile width="80" height="80" active-class="no-active" class="pa-0" block to="/login">
                    <div class="text-center">
                        <v-icon color="primary" size="32" class="d-block mx-auto">mdi-lock-outline</v-icon>
                        <span>로그인</span>
                    </div>
                </v-btn>
                <v-btn v-if="logoff" text tile width="80" height="80" active-class="no-active" class="pa-0" block to="/join">
                    <div class="text-center">
                        <v-icon color="primary" size="32" class="d-block mx-auto">mdi-account-plus-outline</v-icon>
                        <span>회원가입</span>
                    </div>
                </v-btn>
                <v-btn v-if="logon" text tile width="80" height="80" class="pa-0" active-class="no-active" block to="/mypage/cashes/inquiry">
                    <div class="text-center">
                        <v-icon color="primary" size="32" class="d-block mx-auto">mdi-circle-multiple-outline</v-icon>
                        <template v-if="hovers">
                            <span> {{ (user?.cash || 0)?.format?.() }} 원 </span>
                        </template>
                        <template v-else>
                            <span> 보유캐시 </span>
                        </template>
                    </div>
                </v-btn>
                <v-btn v-if="logon" text tile width="80" height="80" class="pa-0" active-class="no-active" block to="/mypage/cashes/charge">
                    <div class="text-center">
                        <v-icon color="primary" size="32" class="d-block mx-auto">mdi-credit-card-plus-outline</v-icon>
                        <span>캐시충전</span>
                    </div>
                </v-btn>
                <v-btn text tile width="80" height="80" active-class="no-active" class="pa-0" block to="/exchange">
                    <div class="text-center">
                        <v-icon color="primary" size="32" class="d-block mx-auto">mdi-gift-outline</v-icon>
                        <span>교환소</span>
                    </div>
                </v-btn>
                <v-btn text tile width="80" height="80" class="pa-0" active-class="no-active" block to="/mypage/shop/carts">
                    <div class="text-center">
                        <v-icon color="primary" size="32" class="d-block mx-auto">mdi-cart-outline</v-icon>
                        <span>장바구니</span>
                    </div>
                </v-btn>
                <v-btn v-if="logon" text tile width="80" height="80" active-class="no-active" class="pa-0" block to="/mypage">
                    <div class="text-center">
                        <v-icon color="primary" size="32" class="d-block mx-auto">mdi-account-outline</v-icon>
                        <span>마이페이지</span>
                    </div>
                </v-btn>
                <v-btn v-if="logon" text tile width="80" height="80" active-class="no-active" class="pa-0" block @click="$emit('logout')">
                    <div class="text-center">
                        <v-icon color="primary" size="32" class="d-block mx-auto">mdi-lock-outline</v-icon>
                        <span>로그아웃</span>
                    </div>
                </v-btn>
            </v-card>
        </v-hover>

        <recent-products class="ml-auto mr-0 mt-4" />
    </floating-actions>
</template>

<script>
import FloatingActions from "./fab/floating-actions.vue";
import RecentProducts from "@/components/client/main/recent-products.vue";
import { mapActions, mapState } from "vuex";

export default {
    components: {
        FloatingActions,
        RecentProducts,
    },
    props: {
        logon: { type: Boolean, default: false },
        logoff: { type: Boolean, default: false },
    },
    data: () => ({
        hovers: false,
    }),
    computed: {
        ...mapState(["user"]),
    },
    mounted() {
        this.init();
    },
    watch: {
        logon() {
            this.init();
        },
    },
    methods: {
        ...mapActions(["getUser"]),
        init() {
            if (this.logon) this.getUser();
        },
    },
};
</script>

<style lang="scss" scoped>
/* quick-menu */
.quick-menu {
    min-width: 80px;

    transition-duration: 0.2s;
    transition-property: min-width;
    transition-timing-function: ease-in-out;

    &.hovers {
        min-width: 190px;

        &::v-deep {
            .v-btn__content {
                justify-content: start;
                padding: 0 16px;
                & > div {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 16px;

                    & > span {
                        font-size: 18px !important;
                    }
                }
            }
        }
    }
    .point {
        display: block;
        position: absolute;
        top: -60px;
        left: 8px;
        margin: 0 auto 7px;
        animation: point 2s ease infinite;
    }

    &::v-deep .v-btn__content span {
        font-size: 14px !important;
        letter-spacing: -0.06em !important;
    }

    img {
        margin-left: 8px;
    }
}
@keyframes point {
    0%,
    30%,
    60%,
    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
    15%,
    45% {
        -webkit-transform: translateY(-10px);
        transform: translateY(-10px);
    }
}
@media (max-width: 768px) {
    .quick-menu {
        img {
            margin-left: 6px;
            width: auto;
            height: 20px;
        }
    }
}
</style>
